module.exports = __webpack_public_path__ + "media/images/google-plus-56ec5033b612490eb4220a1dc8e98985.png";